import { Asset } from '@/api/generatedApi';
import { useToast } from '@/hooks/useToast';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { getAssetFileName } from '@/utils/assets';
import { downloadFromSource } from '@/utils/downloadUtils';

export const useDownloadAsset = () => {
  const { showToast } = useToast();
  const { getTenantId } = useTenants();

  const downloadAsset = async (asset: Asset) => {
    try {
      showToast({ message: 'Downloading asset...', type: 'info' });
      const { data, headers } = await api.assets.assetDownload(getTenantId(), asset.id, { format: 'blob' });

      const fallbackFilename = getAssetFileName(asset) || `asset_${asset.id}`;
      await downloadFromSource(
        { data, headers: headers as Record<string, string | undefined> },
        { autoDetectFilename: true, fallbackFilename }
      );
      showToast({ message: 'Asset downloaded successfully', type: 'success' });
    } catch (error) {
      console.error('Download error:', error);
      showToast({ message: 'Error downloading file', type: 'error' });
    }
  };

  return { downloadAsset };
};
